import { ActionType } from '../action-types/index';
import { Action } from '../actions';

const initialState = true;

const reducer = (state: boolean = initialState, action: Action): boolean => {
  switch (action.type) {
    case ActionType.UNAUTHORIZED:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
